




















import Vue from 'vue';
import { propOfType } from '@/services/utils';
import BaseInput from './BaseInput.vue';

export default Vue.extend({
  components: { BaseInput },
  props: {
    value: propOfType<string>(''),
    disabled: propOfType<boolean>(false),
    type: propOfType<string>('text'),
    placeholder: propOfType<string>(''),
    inputId: propOfType<string>(String(new Date().getMilliseconds() + Math.random())),
    validationError: propOfType<string | null>(null),
    autocomplete: propOfType<boolean | 'new-password'>(true),
  },
  methods: {
    onInput(value: string) {
      this.$emit('input', value);
    },
  },
});
